module.exports = __webpack_public_path__ + "static/media/support-share-badge.46fbef67.png";